import { SerializableObject } from '../../common-react/core';

export class PostalCodeVerification extends SerializableObject {
  public valid: boolean;
  public invalidMessage: string;
  public countryCode: string;
  public postalCode: string;
}
